import { atom } from 'jotai';

export const showMapViewAtom = atom<boolean>(false);
